// angular modules
// DSS Documentation on Angular - http://tiny.sc/cgangular
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
//import { TextMaskModule } from 'angular2-text-mask';

// soco modules
import { SocoAlertModule } from '@soco/alert';
import { SocoCommonModule } from '@soco/common';
import { SocoConfigurationModule } from '@soco/configuration';
import { SocoCoreModule } from '@soco/core';
import { SocoFormsModule } from '@soco/forms';
import { SocoHttpModule } from '@soco/http';
import { SocoModalModule } from '@soco/modal';
import { SocoUIThemeModule } from '@soco/ui-theme';

// app modules
import { CoreModule } from './core/core.module';
import { ComponentsModule } from './components/components.module';
import { HomeModule } from './home/home.module';
import { SampleModule } from './sample/sample.module';
import { UserModule } from './user/user.module';
import { RescheduleModule } from './reschedule/reschedule.module';
import { ScheduleModule } from './schedule/schedule.module';

// app component and routing
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
    imports: [
        // angular modules
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,        
        //TextMaskModule,

        // soco modules
        SocoAlertModule,
        SocoCommonModule,
        SocoConfigurationModule,
        SocoCoreModule,
        SocoFormsModule,
        SocoHttpModule,
        SocoModalModule,
        SocoUIThemeModule,

        // app modules
        CoreModule,
        ComponentsModule,
        HomeModule,
        SampleModule,
        UserModule,
        RescheduleModule,
        ScheduleModule,

        // routing module
        AppRoutingModule

    ],
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

